import { redirect, type RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { contractsLoader } from './contracts-loader';

export const contractsRoutes: RouteObject = {
  loader: contractsLoader,
  children: [
    {
      path: '/admin/contracts',
      lazy: lazyComponent(
        () => import('@pages/tenant/contracts/contracts-list-page'),
        'ContractsListPage',
      ),
    },
    {
      path: '/admin/contracts/:contractId',
      lazy: lazyComponent(
        () => import('@pages/tenant/contract/contract-details-page'),
        'ContractDetailsPage',
      ),
      children: [
        {
          index: true,
          loader: ({ params }) =>
            redirect(`/admin/contracts/${params.contractId}/details`),
        },
        {
          path: 'details',
          lazy: lazyComponent(
            () => import('@pages/tenant/contract/contract-details-page'),
            'ContractDetailsTab',
          ),
        },
        {
          path: 'transactions',
          children: [
            {
              index: true,
              loader: ({ params }) =>
                redirect(`/admin/contracts/${params.contractId}/transactions/financial`),
            },
            {
              path: ':view',
              lazy: lazyComponent(
                () => import('@pages/tenant/contract/contract-details-page'),
                'ContractTransactionsTab',
              ),
            },
          ],
        },
        {
          path: 'limitations',
          lazy: lazyComponent(
            () => import('@pages/tenant/contract/contract-details-page'),
            'ContractLimitationsTab',
          ),
        },
      ],
    },
  ],
};
